<script lang="ts" setup>
import { ref } from 'vue';
import Buttons from '../partials/Buttons.vue';
import MoreMenu from '../partials/MoreMenu.vue';
import Definitions from '../partials/Definitions.vue';

const props = withDefaults(defineProps<{
    advanced?: boolean;
}>(), {
    advanced: true
});

const definitions = ref(null);
const canManage = ref(false);
const show = ref(false);

function onChange()
{
    definitions.value.reload();
}
</script>

<template>
    <button type="button" class="btn btn-secondary" @click="show = !show">
        {{ $t('[[[Filtry]]]') }}
        <i class="fas fa-fw fa-filters" />
    </button>
    <IdeoModal v-model="show" size="xxl" :title="$t('[[[Filtry]]]')">
        <div class="d-flex flex-wrap row-gap-1">
            <slot name="default" />
            <div :style="{ order: 99999 }">
                <MoreMenu />
            </div>
        </div>
        <template #modal-footer="{ cancel }">
            <Buttons v-model:manage="canManage" :border="false" :advanced="props.advanced" @change="onChange" />
            <button type="button" class="btn btn-light ms-auto" @click.stop="cancel">
                {{ $t('[[[Zamknij]]]') }}
            </button>
        </template>
    </IdeoModal>
    <Definitions v-if="props.advanced" ref="definitions" v-model:manage="canManage" />
</template>
